import ThemeRoutes from './theme.routes';

export default [
  ...ThemeRoutes
]
